import { useEffect, useState } from 'react'
import axios from 'axios'
import { RotatingLines } from "react-loader-spinner"

let error = []//array gestione errori insert foto

function AddImg({ numero, folder, invioFoto }) {
    const numFoto = numero// NUMERO MASSIMO DI FOTO (è l'index nel loop in html)

    const [foto, setFoto] = useState([])
    const [caricamento, setCaricamento] = useState(null)
    const [msg, setMsg] = useState([])

    const imageChange = async (e) => {
        if (e.target.files[0]) {
            const el = e.target.getAttribute('data-val')//posizione della foto in array 'foto'
            const eT = e.target.files[0]; error = []; setMsg(error)
            if (eT.type.startsWith('image/')) {
                setCaricamento('Caricamento in corso...')

                // RINOMINAZIONE FOTO CON NOME RANDOM
                let extens = eT.name.substring(eT.name.lastIndexOf('.') + 1)// ricavo l'estensione
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                let result = ''
                const charactersLength = characters.length
                for (let i = 0; i < 15; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength))
                }
                const zxc = `ZE_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome alla foto

                // ------ ACCETTAZIONE IMMAGINE ---------------------------------------- 
                try {
                    const fd = new FormData()
                    const datiFoto = { foto: eT, nomeFoto: zxc, stato: 'siAwsBucket', folder: folder }
                    Object.entries(datiFoto).forEach(([chiave, valore]) => fd.append(chiave, valore))
                    const res = await axios.post(`/convertJpegBase64`, fd, {
                        headers: { "Content-Type": "multipart/form-data" }
                    })
                    if (res.data === 'success') {
                        setFoto(foto.concat(`ZE_${result}.webp`))//per preview 
                        setCaricamento(null)
                        console.log('el:', el)
                        document.getElementById('label' + el).style.display = 'none'// tolgo '+foto'
                        el < numFoto.length - 1 && ( //risettaggio input disabled = false
                            document.getElementById('upload-photo' + (parseInt(el) + 1)).disabled = false)
                    } else {//upload foto failed
                        document.getElementById('upload-photo' + el).value = ''
                        setCaricamento('*** problemi con il server...riprova ***')
                    }
                } catch (err) { console.log(err) }
            } else {//immagine type non conforme      
                error[el] = 'Tipo immagine non conforme'
                setMsg(error)
                e.target.value = ""; return
            }
        }
    }
    const imageRemove = async (e) => {
        setMsg(null); setCaricamento(null); error = []
        const el = e.target.getAttribute("data-val")//posizione della foto da eliminare in array 'foto'
        document.getElementById('upload-photo' + el).value = ''
        const bj = foto.length - 1

        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                const nj = [...foto]
                nj.splice(el, 1)
                setFoto(nj)
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('label' + bj).style.display = 'block'//visualizzo '+foto'  
                }, 50)
            }, speed)
        }
        try {
            axios.delete(`/delete-img/${foto[el]}`, { data: { folder: folder } })
            // const res2 = await axios.post(`/removeImage/eventi`, fd)//rimuovo foto da cloudinary
        } catch (err) { setCaricamento('*** Problemi con la connessione...riprova ***'); console.error(err); return }
        removeFadeOut(document.getElementById('preview' + el), 200)
        removeFadeOut(document.getElementById('iconaElimina' + el), 200)

        //RISETTAGGIO INPUT FOTO = DISABLED
        let index = foto.length - 1
        for (let h = 1; h <= numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
            if (h > (index + 1)) {
                document.getElementById('upload-photo' + (h - 1)).disabled = true
            }
        }
    }

    useEffect(() => { invioFoto(foto) }, [foto])
    return (<>
        <div>
            <h4 style={{ marginTop: '3rem' }}>AGGIUNGI IMMAGINI</h4>
            <p><i>Se aggiungi immagini all'evento otterrai più visualizzazioni</i></p><br />
            <div className='gridAddEvento2'>
                {numFoto.map(elem => (
                    <div key={elem} className='fotoEvento'>
                        <label htmlFor={"upload-photo" + elem} style={{ cursor: 'pointer' }} id={'label' + elem}>
                            {elem === 0 ? <span id={'label' + elem} style={{ fontSize: 'small' }}>+ Foto principale</span> : <span>+foto</span>}
                        </label>
                        {foto[elem] && //preview
                            <div>
                                <div style={{ marginTop: '-25px' }}>
                                    <button style={{ marginLeft: '5rem', border: 'transparent', backgroundColor: 'transparent' }} data-val={elem}
                                        onClick={imageRemove} id={'iconaElimina' + elem} type='button'>
                                        ❌
                                    </button>
                                </div>
                                <span id={'preview' + elem}>
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/${folder}${foto[elem]}`} style={{ maxWidth: '100px', height: '74px' }} alt="" />
                                </span>
                            </div>
                        }
                        {error[elem] &&
                            <p id={'msg' + elem} style={{ fontSize: 'small' }}>{msg[elem]}</p>
                        }
                        <input id={'upload-photo' + elem} style={{ opacity: '0', fontSize: '0px' }}
                            type='file' data-val={elem}
                            name={'foto' + elem}
                            accept="image/*"
                            onChange={imageChange} />
                    </div>
                ))}
            </div>
            <div className='mt-1' style={{ fontWeight: '600' }}>{caricamento}
                {caricamento === 'Caricamento in corso...' &&
                    <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                }
            </div><br /><br />
        </div>
    </>)
}
export default AddImg